export default {
  state: {
    api_key: null,
    empresa: {

    }
  },
  mutations: {
    setApiKey(state, payload) {
      state.api_key = payload
    },
    setEmpresa(state, payload) {
      state.empresa = payload
    },
  },
  actions: {
    definirApiKey({ commit }, payload) {
      commit('setApiKey', payload)
    },
    definirEmpresa({ commit }, payload) {
      commit('setEmpresa', payload)
    }
  },
  getters: {
    getApiKey(state) {
      return state.api_key
    },
    getEmpresa(state) {
      return state.empresa
    }
  }
}
